import { debounce } from 'lodash';
import { useEffect, useMemo, useRef } from 'react';

export default function useDebounce<T extends (...args: any[]) => any>(
  func: T,
  wait?: number,
  options?: {
    leading?: boolean;
    maxWait?: number;
    trailing?: boolean;
  },
  deps: any[] = [],
) {
  const debouncedFnRef = useRef<ReturnType<typeof debounce>>();

  debouncedFnRef.current = useMemo(() => {
    if (debouncedFnRef.current) {
      debouncedFnRef.current.cancel();
    }

    return debounce(func, wait, options);
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, deps);

  useEffect(() => () => debouncedFnRef.current && debouncedFnRef.current.cancel(), []);

  return debouncedFnRef.current;
}
